<template>
  <fragment>
    <form @submit.prevent="handleGetRequets">
      <page-head
        title="البحث في الطلبات"
        :xlarge="!!searchQuery.partyType"
      >
        <v-row>
          <v-col
            v-for="(filter, index) in filters"
            :key="filter.name"
            cols="12"
            :lg="index <= 1 ? '2' : '3'"
          >
            <naj-input
              v-mask="'##########'"
              :type-id="filter.typeId"
              :label="filter.label"
              :value.sync="searchQuery[filter.name]"
              :items="getSelectOptions(filter.name)"
              item-text="name"
              item-value="id"
            ></naj-input>
          </v-col>

          <v-col
            cols="1"
            class="d-flex align-center"
          >
            <naj-button
              type="submit"
              :loading="loading"
              full-width
            >
              البحث
            </naj-button>
          </v-col>
        </v-row>
      </page-head>
    </form>

    <page-content :xlarge="!!searchQuery.partyType">
      <naj-box
        title="نتائج البحث"
        disable-collapsing
      >
        <template v-slot:header="{}">
          <naj-button
            color="primary"
            @click="handleNewRequestPopup"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            طلب جديد
          </naj-button>

          <naj-modal
            ref="newRequestModal"
            title="إضافة طلب جديد"
            :width="600"
            :footer="true"
          >
            <naj-input
              :type-id="formFieldType.selectbox"
              :items="requestTypes"
              :value.sync="requestTypeValue"
              item-text="title"
              item-value="name"
              label="نوع الطلب"
            ></naj-input>

            <template slot="actions">
              <naj-button :to="`/cases/case-related-request/${requestTypeValue}/new`">
                طلب جديد
              </naj-button>
            </template>
          </naj-modal>
        </template>

        <naj-data-table
          no-header
          :headers="headers"
          :loading="loading"
          :items="data.list"
          pagination
          :items-per-page="pagination.pageSize"
          :page-index="pagination.pageIndex"
          :server-items-length="pagination.totalCount"
          @update:pageIndex="onPageChange"
        >
          <template slot-scope="{item}">
            <div class="item-action">
              <router-link
                :to="`/cases/case-related-request/${RequestTypesIds[item.requestTypeId]}/${item.objectKey}`"
                class="new-request-button"
              >
                <naj-button
                  outlined
                  size="small"
                >
                  عرض
                </naj-button>
              </router-link>
            </div>
          </template>

          <template v-slot:item.showRequest="{item}">
            <naj-button
              v-if="isRequestNotCompleted(item.requestStatusId)"
              size="small"
              outlined
              tooltip-message="لمعرفة أسباب عدم الاكتمال و كذلك العمليات التي تمت على الطلب، اضغط هنا"
              @click="handleOpenRecordModel(item.objectKey)"
            >
              سجل الطلب
            </naj-button>
          </template>
        </naj-data-table>
      </naj-box>

      <request-records-modal
        :request-object-key="activeRequestRecords"
        :modal-visibility.sync="recordsModal[activeRequestRecords]"
        :is-courts-request-previous-replies="true"
        @onClose="handleCloseRecordModel(activeRequestRecords)"
      >
      </request-records-modal>
    </page-content>
  </fragment>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import RequestRecordsModal from '@/modules/lawsuit/components/request-records-modal';
import { requestStatus, RequestTypes, RequestTypesIds } from '@/helpers/enum';

const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  components: { RequestRecordsModal },
  data() {
    return {
      loading: false,
      requestTypeValue: 'add-representative',
      activeRequestRecords: null,
      recordsModal: {},
      requestTypes: Object.values(RequestTypes),
      RequestTypesIds,
      data: { list: [] },
      pagination: {
        pageSize: 20,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      searchQuery: {},
      filters: [
        {
          name: 'requestCode',
          label: 'رقم الطلب',
          typeId: 1,
        },
        {
          name: 'courtId',
          label: 'المحكمة',
          typeId: 4,
        },
        {
          name: 'fromRequestDate',
          label: 'التاريخ من',
          typeId: 3,
        },
        {
          name: 'toRequestDate',
          label: 'التاريخ الى',
          typeId: 3,
        },
      ],
      headers: [
        {
          value: 'requestCode',
          text: 'رقم الطلب',
        },
        {
          value: 'requestTypeName',
          text: 'نوع الطلب',
        },
        {
          value: 'caseCode',
          text: 'رقم القضية',
        },
        {
          value: 'courtName',
          text: 'المحكمة',
        },
        {
          value: 'caseTypeName',
          text: 'نوع الدعوى',
        },
        {
          value: 'requestStatusName',
          text: 'حالة الطلب',
          width: '10%',
        },
        {
          value: 'showRequest',
          text: 'سجل الطلب',
        },
        {
          value: 'action',
          text: 'الإجراء',
        },
      ],
    };
  },
  computed: { ...mapLUTState(['courts']) },
  mounted() {
    this.handleGetRequets();
    this.getCourts();
  },
  methods: {
    ...mapActions(['getRequests']),
    ...mapLUTActions(['getCourts']),
    onPageChange(pageIndex) {
      this.pagination = {
        ...this.pagination,
        pageIndex,
      };
      this.handleGetRequets();
    },
    handleGetRequets() {
      this.loading = true;

      this.getRequests({
        ...this.searchQuery,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.data = data;
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSelectOptions(name) {
      if (name === 'courtId') {
        return this.courts;
      }

      return [];
    },
    handleOpenRecordModel(objectKey) {
      this.activeRequestRecords = objectKey;
      this.recordsModal = {
        ...this.recordsModal,
        [objectKey]: true,
      };
    },
    handleCloseRecordModel(objectKey) {
      this.activeRequestRecords = null;
      this.recordsModal = {
        ...this.recordsModal,
        [objectKey]: false,
      };
    },
    isRequestNotCompleted(statusId) {
      return statusId === requestStatus.NotCompleted;
    },
    handleNewRequestPopup() {
      this.$refs.newRequestModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.new-request-button {
  margin-right: auto;
}
.search-button {
  margin-right: auto;
}
.item-action {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: '100%';
}
</style>
